import React from 'react'

const Plus = props => (
  <svg
    width={props.width ? props.width : '12'}
    height={props.height ? props.height : '12'}
    viewBox='0 0 12 12'
    fill={props ? props.color : '#1D79FB'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.00033 0.666748C6.36852 0.666748 6.66699 0.965225 6.66699 1.33341V5.33341H10.667C11.0352 5.33341 11.3337 5.63189 11.3337 6.00008C11.3337 6.36827 11.0352 6.66675 10.667 6.66675H6.66699V10.6667C6.66699 11.0349 6.36852 11.3334 6.00033 11.3334C5.63214 11.3334 5.33366 11.0349 5.33366 10.6667V6.66675H1.33366C0.965469 6.66675 0.666992 6.36827 0.666992 6.00008C0.666992 5.63189 0.965469 5.33341 1.33366 5.33341H5.33366V1.33341C5.33366 0.965225 5.63214 0.666748 6.00033 0.666748Z'
    />
  </svg>
)

export default Plus
